import React, { Component } from 'react'
import { Project } from '../../schema/types.d'

interface SuggestionsProps {
  projects: Project.Project[]
}

class Suggestions extends Component<SuggestionsProps> {
  render() {
    const options = this.props.projects.map(p => (
      <li key={p.id}>
        {p.projectNumber} : {p.name}
      </li>
    ))
    return <ul>{options}</ul>
  }
}

interface FilterProps {
  changeSearch: (searchText: string) => void
  placeholder: string
  title: string
}
class Filter extends Component<FilterProps> {
  changeSearch(event) {
    if (event.key === 'Enter') {
      this.props.changeSearch(event.target.value)
    }
  }

  render() {
    return (
      <div className="pa3 ph5-ns">
        <div className="di pl4">
          <label htmlFor="filter_string" className="f6 b black-60 pr1">
            {this.props.title}
          </label>
          <input
            ref="filter_string"
            className="w-100 input-reset ba b--black-20 pa2 mb2"
            type="text"
            onKeyPress={this.changeSearch.bind(this)}
            placeholder={this.props.placeholder}
          />
        </div>
      </div>
    )
  }
}

export default Filter
